// Data for programmatic route SEO landing pages
export const ROUTES_DATA = {
  "jodhpur-to-jaisalmer": {
    from: "Jodhpur",
    to: "Jaisalmer",
    slug: "jodhpur-to-jaisalmer",
    distance: "285 km",
    duration: "5 hrs 15 mins",
    heroImage: "https://images.pexels.com/photos/35130760/pexels-photo-35130760.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
    tagline: "The Golden Fortress awaits.",
    intro: "One of the most iconic desert drives in India — from Jodhpur, the Blue City, to Jaisalmer, the Golden City. Endless dunes on one side, camels and windmills on the other. Book a Mamta Tours taxi from Jodhpur to Jaisalmer for an unforgettable Rajasthan road-trip.",
    highlights: [
      "Iconic Jaisalmer Fort (a living UNESCO fort)",
      "Sam Sand Dunes desert safari at sunset",
      "Patwon Ki Haveli, Nathmalji Ki Haveli",
      "Gadisar Lake evening boat rides",
      "Longewala War Memorial (day-trip)",
    ],
    itinerary: [
      { time: "06:00 AM", step: "Pickup from your Jodhpur hotel / residence" },
      { time: "07:30 AM", step: "Chai break at Balesar highway dhaba" },
      { time: "10:00 AM", step: "Photo-stop at Pokhran Fort en route" },
      { time: "12:30 PM", step: "Arrive Jaisalmer — hotel check-in" },
      { time: "Evening", step: "Sam Sand Dunes safari + cultural night" },
    ],
    faqs: [
      { q: "How long does it take to reach Jaisalmer from Jodhpur by taxi?", a: "Approximately 5 hours 15 minutes with one comfort break — the highway is smooth and scenic." },
      { q: "What is the best car for Jodhpur to Jaisalmer?", a: "For 2–4 people, a Swift Dzire or Etios is ideal. For 5–6 travellers with luggage, we recommend the Innova Crysta. Groups take our A/C Tempo Traveller." },
      { q: "Is one-way taxi available from Jodhpur to Jaisalmer?", a: "Yes — Mamta Tours offers both one-way and round-trip Jodhpur to Jaisalmer taxi at transparent fixed rates." },
    ],
    seoTitle: "Jodhpur to Jaisalmer Taxi | One-way & Round-trip Cab — Mamta Tours",
    seoDescription: "Book a Jodhpur to Jaisalmer taxi with Mamta Tours. One-way cab, round-trip, Innova, Dzire, Tempo Traveller — professional drivers, sanitized cars, best price. Call +91 8107172107.",
  },
  "jodhpur-to-udaipur": {
    from: "Jodhpur",
    to: "Udaipur",
    slug: "jodhpur-to-udaipur",
    distance: "252 km",
    duration: "4 hrs 45 mins",
    heroImage: "https://images.pexels.com/photos/27960113/pexels-photo-27960113.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
    tagline: "Blue City to City of Lakes.",
    intro: "The most romantic route in Rajasthan — from Jodhpur's blue lanes to Udaipur's mirror-like lakes and marble palaces. Mamta Tours drivers know every scenic shortcut — including a stop at the breathtaking Ranakpur Jain Temples along the way.",
    highlights: [
      "Ranakpur Jain Temple stopover (marble masterpiece)",
      "Lake Pichola boat ride at sunset",
      "City Palace & Jagdish Temple",
      "Sajjangarh Monsoon Palace viewpoint",
      "Kumbhalgarh Fort (day-trip option)",
    ],
    itinerary: [
      { time: "07:00 AM", step: "Pickup from Jodhpur" },
      { time: "10:00 AM", step: "Ranakpur Temple visit (1 hour)" },
      { time: "12:00 PM", step: "Lunch stop at highway restaurant" },
      { time: "01:30 PM", step: "Arrive Udaipur — hotel check-in" },
      { time: "Evening", step: "Lake Pichola boat ride, City Palace" },
    ],
    faqs: [
      { q: "How long is Jodhpur to Udaipur by cab?", a: "About 4h 45m via NH-62. With a Ranakpur stop, plan for 6-7 hours door-to-door." },
      { q: "Can I stop at Ranakpur en route?", a: "Absolutely. Ranakpur is a Mamta Tours signature stop — the driver waits while you visit the temple." },
      { q: "Which is the best car for Jodhpur to Udaipur?", a: "Ertiga or Innova for family comfort; Dzire for couples; Crysta for premium luggage-heavy trips." },
    ],
    seoTitle: "Jodhpur to Udaipur Taxi | Cab via Ranakpur — Mamta Tours",
    seoDescription: "Book Jodhpur to Udaipur taxi with a Ranakpur stopover. One-way & round-trip cabs — Dzire, Innova, Crysta, Tempo Traveller. Professional drivers. Call +91 8107172107.",
  },
  "jodhpur-to-jaipur": {
    from: "Jodhpur",
    to: "Jaipur",
    slug: "jodhpur-to-jaipur",
    distance: "336 km",
    duration: "5 hrs 45 mins",
    heroImage: "https://images.pexels.com/photos/2413613/pexels-photo-2413613.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800",
    tagline: "Blue City meets Pink City.",
    intro: "A smooth highway drive from Jodhpur to Jaipur — Rajasthan's capital and the crown of the Golden Triangle. Book a Mamta Tours cab from Jodhpur to Jaipur and enjoy air-conditioned comfort, professional drivers and door-to-door pickup at unbeatable rates.",
    highlights: [
      "Amber Fort (Amer Palace)",
      "Hawa Mahal — the Palace of Winds",
      "City Palace & Jantar Mantar",
      "Nahargarh Fort viewpoint at dusk",
      "Chokhi Dhani cultural village dinner",
    ],
    itinerary: [
      { time: "06:30 AM", step: "Pickup from Jodhpur" },
      { time: "09:30 AM", step: "Breakfast stop at Merta highway" },
      { time: "12:30 PM", step: "Arrive Jaipur — hotel check-in" },
      { time: "Afternoon", step: "Amber Fort + City Palace sightseeing" },
      { time: "Evening", step: "Hawa Mahal & Chokhi Dhani cultural dinner" },
    ],
    faqs: [
      { q: "How much time does Jodhpur to Jaipur taxi take?", a: "About 5 hours 45 minutes on NH-62 with one stop." },
      { q: "Is one-way Jodhpur to Jaipur cab available?", a: "Yes — Mamta Tours offers one-way drops to Jaipur at transparent flat rates. Great value if you don't need a return car." },
      { q: "Can I do a Jodhpur–Jaipur–Delhi route?", a: "Certainly. We offer multi-city outstation cabs and Rajasthan Golden Triangle packages with a dedicated driver." },
    ],
    seoTitle: "Jodhpur to Jaipur Taxi | One-way Cab from Mamta Tours",
    seoDescription: "Reliable Jodhpur to Jaipur taxi with Mamta Tours. One-way and round-trip cabs — Dzire, Innova, Crysta & Tempo Traveller. Instant WhatsApp booking. Call +91 8107172107.",
  },
};
